// extracted by mini-css-extract-plugin
export default {"role__container":"styles_role__container__qPrzI"};